import React, {Component} from 'react';
import './UserSignaturePage.css';
import { Page, Navbar } from 'framework7-react';
import Label from "../../label/Label";
import {signaturePopupController} from "../../../controllers/signaturePopupController";
import PrimaryButton from "../../primaryButton/PrimaryButton";
import toasts from "../../../utils/toasts";
import mainAPI from "../../../api/MainAPI";


export default class UserSignaturePage extends Component{
	constructor(props) {
		super(props);
		this.state = {signature_img:null};
	}
	onSignatureComplete = (signature_img) => {
		this.setState({value:{signature_img}})
	}
	onSignatureBoxTouch = () => {
		signaturePopupController.show(this.onSignatureComplete)
	}
	continue = async () => {
		const response = await mainAPI.user_signature.create({signature_img: this.state?.value?.signature_img});
		if(response) {
			toasts.show('Signature saved');
			window.f7.views.code_auth.router.navigate('/code-auth/', {props: {onClose: this.props.onClose}});
		}else{
			toasts.error('Something went wrong');
		}
	};

  render(){
    return(
    <Page className="g-user-signature-page">
			<Navbar title="Confirm Signature" />
			<Label large dark >Why we’re asking</Label>

			<Label dark-gray>As a witness, your signature is required for DEA-compliant records</Label>

			<Label dark-gray>We collect your signature <b>once</b> so you don’t need to re-sign every action you witness.</Label>

			<Label large dark bole>How your signature is used</Label>

			<Label dark-gray>Included only in reports you witness</Label>
			<Label dark-gray>Used only for compliance and audit purposes</Label>
			<Label dark-gray>Visible only to administrators</Label>
			<Label dark-gray>Never shared with other users</Label>
			<div className={'sig-wrapper'}>
			<div
				className="signature-box"
				onDragEnter={this.onSignatureBoxTouch}
				onTouchStart={this.onSignatureBoxTouch}
				onClick={this.onSignatureBoxTouch}
			>
				{this.state?.value?.signature_img &&<img src={this.state?.value?.signature_img} alt={''} />}
				{!this.state?.value?.signature_img &&<Label className={'sign-text'}>sign</Label>}
			</div>
			</div>
			{this.state?.value?.signature_img && <PrimaryButton center onClick={this.continue}>Continue</PrimaryButton>}

		</Page>
    )
  }
}